module.exports = __webpack_public_path__ + "assets/img/img261.6aafe499.png";